export default __webpack_public_path__ + "static/media/bellWhite.cf4a035b.svg";